import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleText: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBubbleText"><Path fillRule="evenodd" clipRule="evenodd" d="M21.002 19.0357V3L3.00195 3.00003V19.0358H8.65157L11.9939 21.8375L15.3757 19.0358L21.002 19.0357ZM7.99976 8H15.9998V10H7.99976V8ZM7.99976 12V14H15.9998V12H7.99976Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleText;
